export const ALL_WIDGETS = {
  'cycle_time_metric': { title: 'Cycle Time', w: 4, isMetric: true, row:1 },
  'wip_metric': { title: 'WIP',  w: 4, isMetric: true, row:1 },
  'flow_efficiency_metric': { title: 'Flow Efficiency', w: 3, isMetric: true, row:4 },
  'process_metrics': { title: 'Process Metrics', w: 4, isMetric: true, row:1 },
  'cfd_chart': { title: 'Cumulative Flow Diagram', w: 4, isMetric: false, linkTo: 'cfd', row:2 },
  'ctsp_chart': { title: 'Cycle Time Scatterplot', w: 4, isMetric: false, linkTo: 'ctsp', row:2 },
  'ctb_chart': { title: 'Cycle Time Breakdown Chart', w: 4, isMetric: false, linkTo: 'ctb', row:2 },
  'cth_chart': { title: 'Cycle Time Histogram', w: 4, isMetric: false, linkTo: 'cth', row:3 },
  'cta_chart': { title: 'Aging Chart', w: 4, isMetric: false, linkTo: 'cta', row:3 },
  'trc_chart': { title: 'Throughput Run Chart', w: 4, isMetric: false, linkTo: 'trc', row:3 },
};
export const ALL_WIDGETS_SMALL = {
  'cycle_time_metric': { title: 'Cycle Time', w: 4, isMetric: true, row:1 },
  'wip_metric': { title: 'WIP',  w: 4, isMetric: true, row:1 },
  'flow_efficiency_metric': { title: 'Flow Efficiency', w: 3, isMetric: true, row:6 },
  'process_metrics': { title: 'Process Metrics', w: 4, isMetric: true, row:2 },
  'cfd_chart': { title: 'Cumulative Flow Diagram', w: 4, isMetric: false, linkTo: 'cfd', row:2 },
  'ctsp_chart': { title: 'Cycle Time Scatterplot', w: 4, isMetric: false, linkTo: 'ctsp', row:3 },
  'ctb_chart': { title: 'Cycle Time Breakdown Chart', w: 4, isMetric: false, linkTo: 'ctb', row:3 },
  'cth_chart': { title: 'Cycle Time Histogram', w: 4, isMetric: false, linkTo: 'cth', row:4 },
  'cta_chart': { title: 'Aging Chart', w: 4, isMetric: false, linkTo: 'cta', row:4 },
  'trc_chart': { title: 'Throughput Run Chart', w: 4, isMetric: false, linkTo: 'trc', row:5 },
};

const OVERVIEW_DESCRIPTIONS = {
  cycle_time_metric: 'Shows 85th percentile cycle time',
  wip_metric: 'Current work in progress and average age',
  flow_efficiency_metric: 'Average flow efficiency percentage',
  process_metrics: 'System metrics like arrival rate and throughput',
  cfd_chart: 'Visual representation of work flow over time',
  ctsp_chart: 'Distribution of cycle times for completed work',
  ctb_chart: 'Time spent in each process step',
  cth_chart: 'Frequency distribution of cycle times',
  cta_chart: 'Current work items and their ages',
  trc_chart: 'Daily throughput trends over time',
};

export const OVERVIEW_WIDGETS_ARRAY = Object.entries(ALL_WIDGETS).map(([id, props]) => ({
  value: id,
  label: props.title,
  _id: id,
  description: OVERVIEW_DESCRIPTIONS[id] || '',
}));

export const ALL_WIDGET_IDS = Object.keys(ALL_WIDGETS);
